/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Events from './Events/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content"
  
}) {
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--pt-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-7-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-5-Z1Yf8zk': isMedia.mobile ? "0px" : typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-6-Z1Yf8zk': isMedia.mobile ? "0px" : typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--oy-3-Z1Yf8zk': isMedia.mobile ? "visible" : "auto",'--mh-2-Z1Yf8zk': isMedia.mobile ? "100%" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<Events
  viewPath={`${viewPath}/Events`}
/>
</div>
{children}
</React.Fragment>)
}